import { tracker } from '~/plugins/mixpanel'

export default defineNuxtRouteMiddleware((to) => {
  const eventProperties = { page: to.name, path: to.path }
  tracker.track('PageView', eventProperties)
})
